import api from "./api";

export const agentService = {
  // Get all agents
  getAllAgents: async () => {
    const response = await api.get("/agent/list");
    return response.data.data.agents;
  },

  // Get agent by ID
  getAgentById: async (id) => {
    const response = await api.get(`/agent/${id}`);
    return response.data.data.agent;
  },

  // Get pending validations (for agents)
  getPendingValidations: async () => {
    const response = await api.get("/agent/pending-validations");
    return response.data;
  },

  // Update bin item quantity (for agents)
  updateBinItemQuantity: async (binId, itemId, newQuantity) => {
    const response = await api.put("/agent/update-bin-item", {
      binId,
      itemId,
      newQuantity,
    });
    return response.data;
  },

  // Delete bin item (for agents)
  deleteBinItem: async (binId, itemId) => {
    const response = await api.delete("/agent/delete-bin-item", {
      data: { binId, itemId },
    });
    return response.data;
  },

  // Cancel seller order (for agents)
  cancelSellerOrder: async (binId) => {
    const response = await api.post("/agent/cancel-seller-order", {
      binId,
    });
    return response.data;
  },

  // Validate bin (for agents)
  validateBin: async (binId, validationData) => {
    const response = await api.post(`/agent/validate/${binId}`, validationData);
    return response.data;
  },

  // Get validation history (for agents)
  getValidationHistory: async () => {
    const response = await api.get("/agent/validation-history");
    return response.data;
  },

  // Create delivery (for agents)
  createDelivery: async (deliveryData) => {
    const response = await api.post("/agent/delivery", deliveryData);
    return response.data;
  },

  // Get delivery history (for agents)
  getDeliveryHistory: async () => {
    const response = await api.get("/agent/delivery-history");
    return response.data;
  },

  // Redirect order to another agent
  redirectOrder: async (binId, newAgentId) => {
    const response = await api.post(`/agent/redirect-order/${binId}`, {
      newAgentId,
    });
    return response.data;
  },

  // Confirm sale (for agents)
  confirmSale: async (binId) => {
    const response = await api.post(`/agent/confirm-sale/${binId}`);
    return response.data;
  },
};
